export default [
  {
    path: "/",
    redirect: "/center",
  },
  {
    path: "/home",
    name: "homepage",
    component: () => import("@/views/Home/home.vue"),
    meta: {
      show: true,
    },
  },
  {
    path: "/enroll",
    name: "enrollpage",
    component: () => import("@/views/Enroll/index.vue"),
    meta: {
      show: false,
      title: "注册",
      permission:false,
    },
  },
  {
    path: "/forget",
    name: "forgetpage",
    component: () => import("@/views/ForgetPass/index.vue"),
    meta: {
      show: false,
      title: "忘记密码",
      permission:false,
    },
  },
  {
    path: "/login",
    name: "loginpage",
    component: () => import("@/views/Login/index.vue"),
    meta: {
      show: false,
      title: "登录",
      permission:false,
    },
  },
  {
    path: "/orderconfirm",
    name: "order_confirm",
    component: () => import("@/views/Order/Confirm.vue"),
    meta: {
      show: false,
      title: "订单确认",
      permission: false,
    },
  },
  {
    path: "/orderinfo/:id",
    name: "orderinfo",
    component: () => import("@/views/Order/Info.vue"),
    meta: {
      show: false,
      title: "订单详情",
      permission: true,
    },
  },
  {
    path: "/orderpay/:id",
    name: "orderpay",
    component: () => import("@/views/Order/Pay.vue"),
    meta: {
      show: false,
      title: "订单支付",
      permission: true,
    },
  },
  {
    path: "/orderedit/:id/:isCopy",
    name: "orderedit",
    component: () => import("@/views/Order/Edit.vue"),
    meta: {
      show: false,
      title: "订单编辑",
      permission: true,
    },
  },
  {
    path: "/center",
    name: "usercenter",
    component: () => import("@/views/PersonalCenter/PersonalCenter.vue"),
    meta: {
      show: false,
      title: "个人中心",
      permission: true,
      groups:[
        {
          name:'个人中心',
          sort:'0',
          icon:"el-icon-s-platform"
        },
        {
          name:'检验认证订单',
          sort:'1',
          icon:"el-icon-s-order"
        },
        {
          name:'跨国服务',
          sort:'2',
          icon:"el-icon-s-cooperation"
        },
        {
          name:'资金管理',
          sort:'3',
          icon:"el-icon-s-finance"
        },
        {
          name:'设置',
          sort:'4',
          icon:"el-icon-s-tools"
        },
      ]
    },
    redirect: "/center/welcome",
    children: [
      {
        path: "welcome",
        name: "userwellcome",
        component: () =>
          import("@/views/individual/UserLoginInformation/index.vue"),
        meta: { title: "欢迎",index:"0-1", permission: true, groupName:"个人中心"},
      },
      {
        path: "info",
        name: "userinfo",
        component: () => import("@/views/individual/Information/index.vue"),
        meta: { title: "用户信息",index:"4-1", permission: true, groupName:"设置" },
      },
      {
        path: "address",
        name: "useraddress",
        component: () => import("@/views/individual/Address/index.vue"),
        meta: { title: "我的地址",index:"4-2", permission: true , groupName:"设置"},
      },
      {
        path: "invoice",
        name: "userinvoice",
        component: () => import("@/views/individual/invoice/index.vue"),
        meta: { title: "开票信息",index:"4-3", permission: true,groupName:"设置" },
      },
      {
        path: "pwd",
        name: "userpwd",
        component: () => import("@/views/individual/pwdData/index.vue"),
        meta: { title: "修改密码",index:"4-4", permission: true, groupName:"设置" },
      },
      {
        path: "enterprise",
        name: "enterprise",
        component: () => import("@/views/individual/enterprise/index.vue"),
        meta: { title: "企业认证",index:"4-5", permission: true , groupName:"设置"},
      },
      {
        path: "person",
        name: "person",
        component: () => import("@/views/individual/OnePerson/index.vue"),
        meta: { title: "实名认证",index:"4-6", permission: true , groupName:"设置"},
      },
      {
        path: "collect",
        name: "usercollect",
        hidden: true,
        component: () => import("@/views/individual/Collect/index.vue"),
        meta: { title: "我的收藏",index:"4-7", permission: true, groupName:"设置"},
      },
      {
        path: "message",
        name: "usermessage",
        component: () => import("@/views/individual/Message/index.vue"),
        meta: { title: "我的消息",index:"4-8", permission: true, groupName:"设置"},
      },
      {
        path: "feedback",
        name: "userfeedback",
        component: () => import("@/views/individual/FeedBack/index.vue"),
        meta: { title: "反馈意见",index:"4-9", permission: true, groupName:"设置" },
      },

      {
        path: "purse",
        name: "mypurse",
        component: () => import("@/views/Money/myPurse/index.vue"),
        meta: { title: "钱包",index:"3-1", permission: true, groupName:"资金管理" },
      },
      {
        path: "account",
        name: "myaccount",
        component: () => import("@/views/Money/myAccount/index.vue"),
        meta: { title: "银行卡",index:"3-2", permission: true, groupName:"资金管理" },
      },
      {
        path: "makeinvoicelist",
        name: "makeinvoicelist",
        component: () => import("@/views/Invoice/List.vue"),
        meta: { title: "开票列表",index:"3-3", permission: true, groupName:"资金管理" },
      },
      {
        path: "rechargedetail",
        name: "rechargedetail",
        component: () => import("@/views/Money/myRechargeDetail/index.vue"),
        meta: { title: "充值记录", permission: true, groupName:"资金管理" },
      },
      {
        path: "widthdrawdetail",
        name: "widthdrawdetail",
        hidden: true,
        component: () => import("@/views/Money/myWidthDetail/index.vue"),
        meta: { title: "提现记录", permission: true, groupName:"资金管理" },
      },
      {
        path: "buydetail",
        name: "buydetail",
        hidden: true,
        component: () => import("@/views/Money/myBuyData/index.vue"),
        meta: { title: "消费记录", permission: true, groupName:"资金管理" },
      },
      {
        path: "recharge",
        name: "recharge",
        hidden: true,
        component: () => import("@/views/Money/myrecharge/index.vue"),
        meta: { title: "充值", permission: true },
      },
      {
        path: "widthdraw",
        name: "widthdraw",
        hidden: true,
        component: () => import("@/views/Money/mywidthdraw/index.vue"),
        meta: { title: "提现", permission: true },
      },
      {
        path: "loginlogs",
        name: "loginlogs",
        hidden: true,
        component: () => import("@/views/individual/LoginLogs/index.vue"),
        meta: { title: "登录日志", permission: true, show: false },
      },
      {
        path: "orders",
        name: "orders",
        component: () => import("@/views/MyOrders/index.vue"),
        meta: { title: "我的订单",index:"1-1", permission: true, groupName:"检验认证订单" },
      },
      {
        path: "refundlist",
        name: "refundlist",
        component: () => import("@/views/MyOrders/refund.vue"),
        meta: { title: "退款订单",index:"1-2", permission: true, groupName:"检验认证订单" },
      },
      {
        path: "crossorders",
        name: "crossorders",
        component: () => import("@/views/Cross/index.vue"),
        meta: { title: "我的订单",index:"2-1", permission: true, groupName:"跨国服务" },
      },
      {
        path: "crossvat",
        name: "crossvat",
        icon: "el-icon-s-check",
        component: () => import("@/views/CrossVat/index.vue"),
        meta: { title: "VAT服务",index:"2-2", permission: true, groupName:"跨国服务" },
        redirect: "/center/crossvat/vattaxid",
        children:[
          {
            path:"vattaxid",
            name:"vattaxid",
            component:()=>import("@/views/CrossVat/taxid.vue"),
            meta: { title: "VAT税号",index:"2-2-1", permission: true, },
          },
          {
            path:"vatapply",
            name:"vatapply",
            component:()=>import("@/views/CrossVat/apply.vue"),
            meta: { title: "VAT申报",index:"2-2-2", permission: true, },
          },
        ]
      },
      {
        path: "crossepr",
        name: "crossepr",
        component: () => import("@/views/CrossEpr/index.vue"),
        meta: { title: "EPR服务",index:"2-3", permission: true, groupName:"跨国服务" },
        redirect: "/center/crossepr/eprtaxid",
        children:[
          {
            path:"eprtaxid",
            name:"eprtaxid",
            component:()=>import("@/views/CrossEpr/taxid.vue"),
            meta: { title: "EPR税号",index:"2-3-1", permission: true, },
          },
          {
            path:"eprapply",
            name:"eprapply",
            component:()=>import("@/views/CrossEpr/apply.vue"),
            meta: { title: "EPR申报",index:"2-3-2", permission: true, },
          },
        ]
      },
      
      {
        path: "crossbrand",
        name: "crossbrand",
        component: () => import("@/views/CrossBrand/index.vue"),
        meta: { title: "商标服务",index:"2-4", permission: true, groupName:"跨国服务" },
        
      },
      
      
      {
        path: "crossother",
        name: "crossother",
        component: () => import("@/views/CrossOther/index.vue"),
        meta: { title: "其他服务",index:"2-5", permission: true, groupName:"跨国服务" },
        
      },
    ],
  },
  {
    path: "*",
    hidden: true,
    component: () => import("@/views/404/index.vue"),
    meta: {
      title: "404",
      show: false,
    },
  },
];
